export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS";
export const GET_SUBSCRIPTIONS_FAIL = "GET_SUBSCRIPTIONS_FAIL";

export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_FAIL = "CREATE_SUBSCRIPTION_FAIL";

export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION_SUCCESS = "UPDATE_SUBSCRIPTION_SUCCESS";
export const UPDATE_SUBSCRIPTION_FAIL = "UPDATE_SUBSCRIPTION_FAIL";


export const DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTION";
export const DELETE_SUBSCRIPTION_SUCCESS = "DELETE_SUBSCRIPTION_SUCCESS";
export const DELETE_SUBSCRIPTION_FAIL = "DELETE_SUBSCRIPTION_FAIL";


export const getSubscriptions = (tenantId) => ({
  type: GET_SUBSCRIPTIONS,
  tenantId,
});

export const getSubscriptionsFail = (error) => ({
  type: GET_SUBSCRIPTIONS_FAIL,
  error
});

export const getSubscriptionsSuccess = (subscriptions) => ({
  type: GET_SUBSCRIPTIONS_SUCCESS,
  subscriptions
});



export const createSubscription = (subscriptionData) => ({
  type: CREATE_SUBSCRIPTION,
  subscriptionData,
});

export const createSubscriptionFail = (error) => ({
  type: CREATE_SUBSCRIPTION_FAIL,
  error
});

export const createSubscriptionsSuccess = (subscription) => ({
  type: CREATE_SUBSCRIPTION_SUCCESS,
  subscription
});


export const updateSubscription = (subscriptionData) => ({
  type: UPDATE_SUBSCRIPTION,
  subscriptionData,
});

export const updateSubscriptionFail = (error) => ({
  type: UPDATE_SUBSCRIPTION_FAIL,
  error
});

export const updateSubscriptionsSuccess = (subscription) => ({
  type: UPDATE_SUBSCRIPTION_SUCCESS,
  subscription
});


export const deleteSubscription = (subscriptionData) => ({
  type: DELETE_SUBSCRIPTION,
  subscriptionData,
});

export const deleteSubscriptionFail = (error) => ({
  type: DELETE_SUBSCRIPTION_FAIL,
  error
});

export const deleteSubscriptionsSuccess = (subscription) => ({
  type: DELETE_SUBSCRIPTION_SUCCESS,
  subscription
});


